import React from "react";

import { motion, Variants } from "framer-motion";
import SteelBeams from "../../assets/iBeam.jpg";
import Vector1 from "../../assets/Vector.svg";
import Vector2 from "../../assets/Vector (1).svg";
import Vector3 from "../../assets/Vector (2).svg";
import Vector4 from "../../assets/Vector (3).svg";
import Vector5 from "../../assets/Vector (4).svg";

function ChooseUs() {
  const containerVariants: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.15 } },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <motion.div
      className="bg-white pt-48 pb-36 flex flex-col-reverse lg:flex-row justify-between px-10 sm:px-20 lg:px-32"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: "some" }}
      variants={containerVariants}
    >
      {/* Image */}
      <motion.div
        className="w-full lg:w-[35%] lg:self-center"
        variants={itemVariants}
      >
        <img
          src={SteelBeams}
          alt="Stacked steel I-beams for construction"
          className="h-64 w-full rounded-xl object-cover shadow-xl sm:h-80 lg:h-[520px]"
          loading="lazy"
          decoding="async"
        />
      </motion.div>

      {/* Content */}
      <motion.div
        className="w-full lg:w-[63%] xl:w-[58%] mb-10 lg:mb-0"
        variants={containerVariants}
      >
        <motion.h3
          className="text-[#1F1F1E] changa-one-regular text-4xl sm:text-6xl mb-6 mt-3"
          variants={itemVariants}
        >
          WHY CHOOSE US?
        </motion.h3>
        <motion.p
          className="text-[#1E1E1E] text-base poppins-light mb-3.5"
          variants={itemVariants}
        >
          Over 10 years of trusted experience Prime Steel Trading has built
          strong relationships with a wide range of clients. Beyond serving
          construction companies and real estate developers, we have also
          supplied our products to the automotive and mechanical sectors.
        </motion.p>
        <motion.p
          className="text-[#1E1E1E] text-base poppins-light mb-6"
          variants={itemVariants}
        >
          Our steel has been trusted by truck bodybuilders, car mechanics, and
          workshops who use it to manufacture and repair truck bodies, trailers,
          and various industrial components. This diverse experience
          demonstrates our ability to meet the needs of different industries
          with consistent quality and reliable service.
        </motion.p>

        {/* Features */}
        <motion.div
          className="flex flex-wrap justify-between mt-10"
          variants={containerVariants}
        >
          {[
            {
              icon: Vector1,
              title: "Top-Quality Products",
              desc: "Durable steel for every project",
            },
            {
              icon: Vector4,
              title: "Accuracy & Consistency",
              desc: "Every product is milled to the exact size and thickness",
            },
            {
              icon: Vector2,
              title: "Complete Range",
              desc: "SHS, RHS, angles, U-channels, flat bars, sheet metals,Round bar,Round pipe",
            },
            {
              icon: Vector5,
              title: "Expert Support",
              desc: "to help you choose the right material for your projects",
            },
            {
              icon: Vector3,
              title: "Fast & Reliable Service",
              desc: "On-time delivery & responsive support",
            },
          ].map((item, index) => (
            <motion.div
              className="flex max-w-full mb-7"
              key={index}
              variants={itemVariants}
            >
              <div className="w-[40px] h-[40px] shrink-0 bg-[#EEB762] rounded-full mr-[21px] flex justify-center items-center">
                <img src={item.icon} alt="" />
              </div>
              <div className="w-[181px] min-w-0">
                <h3 className="text-[#1E1E1E] text-xl inter-bold">
                  {item.title}
                </h3>
                <span className="text-[#1E1E1E] poppins-light text-xs">
                  {item.desc}
                </span>
              </div>
            </motion.div>
          ))}
        </motion.div>
        <div className="flex justify-end mt-4">
          {/* <button className="border-[2px] border-[#EEB762] px-[27px] py-[10px] rounded-[6px]">
            <span className="poppins-semibold text-base text-[#EEB762]">
              View Detail
            </span>
          </button> */}
        </div>
      </motion.div>
    </motion.div>
  );
}

export default ChooseUs;
